import { getUserProfileV2Async, UserProfile } from '@chr/online-shared-microsite-core';
import { identify, init } from '@fullstory/browser';
import React, { useEffect } from 'react';

export function initialize() {
  init({ orgId: 'o-1CZ68E-na1' });
}

async function identifyUser() {
  const userProfile: UserProfile | null = await getUserProfileV2Async();

  if (!userProfile?.userId) {
    return;
  }

  const userId = userProfile.userId.toString();

  const userVars = {
    displayName: userId,
  };

  identify(userId, userVars);
}

export function IdentifyUser() {
  useEffect(() => {
    void identifyUser();
  }, []);

  return <></>;
}
